<template>
  <div id="Phone">
    <div id="header">
      <div style="display: flex;align-items: center">
        <img src="../../../assets/images/3x/logo.png" alt=""
             style="width:1.04rem;height: 1.04rem;border-radius: 50%;margin-right: 0.19rem">{{appName}}
      </div>
      <div class="minus" @click="showPopup">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div style="margin-top: -0.6rem">
      <van-notice-bar
        left-icon="volume-o"
        :text="$t('message.mar_tip')" style="top: 2.5rem"
      />
      <div id="swipe_area_ph">
        <van-swipe :autoplay="5000" :show-indicators="false" :touchable="false">
          <van-swipe-item v-for="(item,index) in imageArr" :key="index" v-if="imageArr.length>0" @click="godetail(item.title,item.content)">
            <img :src="item.image" style="width: 100%"/>
          </van-swipe-item>
          <van-swipe-item v-if="isMobile">
            <div class="swipeBG swipeBG1"></div>
          </van-swipe-item>
        </van-swipe>
<!--        <div class="swipe_text_area">-->
<!--          <div class="d_t">{{$t('message.index_jdlc')}}</div>-->
<!--          <div class="d_b">-->
<!--            <div>{{$t('message.index_syxq')}}</div>-->
<!--            <van-button type="info" class="btns" style="padding: 0 30px" @click="login">{{$t('message.why_5')}}</van-button>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
<!--    <section id="loanMoney_ph">-->
<!--      <div class="loanMoney_left_content">-->
<!--        <div>{{$t('message.index_pro')}} <span class="line"></span></div>-->
<!--        <div>{{$t('message.index_ty')}}</div>-->
<!--        <div>{{$t('message.index_jd')}}</div>-->
<!--        <div>{{$t('message.index_tips')}}</div>-->
<!--      </div>-->
<!--    </section>-->
    <section id="loanMoney">
      <div class="loanMoney_right_top">
        {{$t('message.loan_need')}}
        <div class="triangle">
          <div></div>
        </div>
      </div>
      <div class="loanMoney_right_content">
        <div class="slide_item">
          <div class="label">{{$t('message.loan_ed')}}</div>
          <div class="qj">
            <span>{{add_comma_toThousands(min)}}{{coin}}</span>
            <span>{{add_comma_toThousands(max)}}{{coin}}</span>
          </div>
          <van-slider v-model="value1" bar-height="6px" :max="max" :min="min" :step="step"/>
        </div>
        <div class="slide_item" style="margin-bottom: 0">
          <div class="label">{{$t('message.with_tx_jkts')}}</div>
          <div class="qj">
            <span>91{{$t('message.tian')}}</span>
            <span>120{{$t('message.tian')}}</span>
          </div>
          <van-slider v-model="value2" bar-height="6px" :max="120" :min="91"/>
        </div>
        <div class="infos">
          <div class="info_items" style=" border-bottom: 1px solid #E6EAEF;">
            <div>{{$t('message.bill_jkqx')}}</div>
            <div>{{getTime}}</div>
          </div>
          <div class="info_items">
            <div>{{$t('message.repay_money')}}</div>
            <div>{{add_comma_toThousands(value1)}}{{coin}}</div>
          </div>
          <div style="margin: 1.2rem 0">
            <van-button type="info" block class="btns" @click="login">{{$t('message.why_5')}}</van-button>
          </div>
        </div>
      </div>
    </section>
    <section id="QS">
      <div class="head_title">
        <div>{{$t('message.we_solve')}} <span class="line"></span></div>
        <div style="padding: 0 0.41rem">{{$t('message.all_ans')}}</div>
      </div>
      <div class="QS_content">
        <div style="background: #fff;height: 247px;position: absolute;z-index: 1;width: 100%"></div>
        <div class="container">
          <div class="QS_content_item">
            <div style="overflow: hidden;">
              <img src="../../../assets/images/index/services-1-4.png" alt="">
            </div>
            <div class="text">
              <h4>{{$t('message.ybxx')}}</h4>
              <div>{{$t('message.ybxx_a')}}</div>
            </div>
          </div>
          <div class="QS_content_item">
            <div style="overflow: hidden;">
              <img src="../../../assets/images/index/services-1-5.png" alt="" >
            </div>
            <div class="text">
              <h4>{{$t('message.dk')}}</h4>
              <div>{{$t('message.dk_a')}}</div>
            </div>
          </div>
          <div class="QS_content_item">
            <div style="overflow: hidden;">
              <img src="../../../assets/images/index/services-1-6.png" alt="">
            </div>

            <div class="text">
              <h4>{{$t('message.dkzf')}}</h4>
              <div>{{$t('message.dkzf_a')}}</div>
            </div>
          </div>
          <div class="q3"><img src="../../../assets/images/index/feature-shape-1-3.png" alt=""></div>
        </div>
      </div>
    </section>
    <section id="reason">
      <div class="q2"><img src="../../../assets/images/index/feature-shape-1-2.png" alt=""></div>
      <div class="head_title">
        <div>{{$t('message.why_c')}} <span class="line"></span></div>
        <div>{{$t('message.why_lh')}}</div>
      </div>
      <div class="reason_content">
        <div class="container">
          <div class="reason_content_item">
            <div>
              <img src="../../../assets/images/index/lilv.png" alt="">
            </div>
            <div class="text">
              {{$t('message.why_1')}}
            </div>
          </div>
          <div class="reason_content_item">
            <div>
              <img src="../../../assets/images/index/chenggonglv.png" alt="">
            </div>
            <div class="text">
              {{$t('message.why_2')}}
            </div>
          </div>
          <div class="reason_content_item">
            <div>
              <img src="../../../assets/images/index/huankuan.png" alt="">
            </div>
            <div class="text">
              {{$t('message.why_3')}}
            </div>
          </div>
          <div class="q1"><img src="../../../assets/images/index/service-shape-1-3.png" alt=""></div>
        </div>
      </div>
    </section>
    <section id="lc">
      <div class="head_title">
        <div>{{$t('message.why_c')}} <span class="line"></span></div>
        <div>{{$t('message.why_apply')}}</div>
      </div>
      <div class="reason_content">
        <div class="container">
          <div class="reason_content">
            <div><img src="../../../assets/images/index/trust-1-1.png" alt=""></div>
            <div style="color: #798490">{{$t('message.index_tips')}}
            </div>
          </div>
        </div>
      </div>
      <div class="container">

        <div class="right">
          <div class="reason_content">
            <div class="items">
              <div>01</div>
              <div>{{$t('message.why_4')}}</div>
            </div>
            <div class="items">
              <div>02</div>
              <div>{{$t('message.why_5')}}</div>
            </div>
            <div class="items">
              <div>03</div>
              <div>{{$t('message.why_6')}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="dk">
      <div id="dk_zz"></div>
      <div class="container" style="position: relative;z-index:2">
        <div>
          <div>{{$t('message.jd')}} <span>/</span> {{$t('message.tm')}} <span>/</span> {{$t('message.aq')}} <span>/</span></div>
          <div>{{$t('message.get_quck')}}</div>
        </div>
        <div>
          <van-button type="info" class="btns" @click="login" style="border: 2px solid #fff;border-radius: 5px;font-weight: 400;font-size: 0.5rem">{{$t('message.apply_loan')}}</van-button>
        </div>
      </div>
    </section>

    <van-popup v-model="show" position="left" :closeable="true">
      <div class="popBox">
        <div class="header">
          <img src="../../../assets/images/3x/logo.png" alt=""
               style="width:1.04rem;height: 1.04rem;border-radius: 50%;margin-right: 0.19rem">{{appName}}
        </div>
        <div class="content">
          <div class="item" @click="lxwm('in')">
            <span >{{$t('message.home')}}</span>
          </div>
          <div class="item" @click="lxwm('QS')">
            <span >{{$t('message.info_cjwt')}}</span>
          </div>
          <div class="item" @click="lxwm('US')">
            <span >{{$t('message.info_lxwm')}}</span>
          </div>
        </div>
        <van-button type="info" block class="btns" @click="login" id="headBtn">{{$t('message.why_5')}}</van-button>
        <div class="version">
          {{VER}}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import img1 from '@/assets/images/index/mobile_swipe.png';
  import img2 from '@/assets/images/index/main-slider-1-2.jpg';
  import img3 from '@/assets/images/index/liucheng-dark.png';
  import img4 from '@/assets/images/index/liucheng.png';
  import img5 from '@/assets/images/index/feiyong.png';
  import img6 from '@/assets/images/index/feiyong-dark.png';
  import {swipe_notice} from '../../../ports/port'

  export default {
    name: "index",
    data() {
      return {
        appName: this.$AppName,
        images: [img1],
        langs: this.$Language,
        value2: 115,
        value1: this.$Language == 'VN' ? 2000000 : 3000,
        coin: this.$coin,
        show: false,
        VER:this.$VERSION,
        isMobile:false,
        imageArr:[]
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      var system = {
        win: false,
        mac: false,
        xll: false
      };
      //检测平台
      var p = navigator.platform;
      system.win = p.indexOf("Win") == 0;
      system.mac = p.indexOf("Mac") == 0;
      system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
      if (!system.win || system.mac || system.xll) {
        swipe_notice({})
          .then(res=>{
            if(res.data.code==200){
              this.imageArr = res.data.data;
            }else{
              this.isMobile = true;
            }
          })
      }else{
        this.isMobile = true;
      }
    },
    computed: {
      min() {
        if (this.langs == 'VN') {
          return '2000000'
        } else {
          return '1500';
        }
      },
      max() {
        if (this.langs == 'VN') {
          return '20000000'
        } else {
          return '5000';
        }
      },
      step() {
        return this.langs == 'VN' ? 500000 : 500;
      },
      getTime() {
        let time;
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        //date对象的set方法，自动折算
        date.setDate(Number(this.value2) + day);
        year = date.getFullYear();
        month = Number(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        day = Number(date.getDate()) < 10 ? '0' + date.getDate() : date.getDate();
        time = day + "-" + month + "-" + year;
        return time;
      }
    },
    methods: {
      godetail(a,b){
        this.$router.push({path:'/gonggao',query:{title:a,content:b}})
      },
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = '.' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
      login() {
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
        if (system.win || system.mac || system.xll) {
          this.$dialog.alert({
            title: this.$t('message.ts'),
            message: this.$t('message.use_phone'),
            confirmButtonText:this.$t('message.determine')
          });
        } else {
          this.$router.push('/auth/register')
        }
      },
      changeIMG(a) {
        if (a == 'IMG1') {
          this.$refs.IMG1.setAttribute("src", img3);
        } else {
          this.$refs.IMG2.setAttribute("src", img6);
        }

      },
      changeIMGLeave(a) {
        if (a == 'IMG1') {
          this.$refs.IMG1.setAttribute("src", img4);
        } else {
          this.$refs.IMG2.setAttribute("src", img5);
        }
      },
      showPopup() {
        this.show = true;
      },
      lxwm(a) {
        switch (a) {
          case 'US':
            this.$router.push('/ContactUS');
            break;
          case 'QS':
            this.$router.push('/problem');
            break;
          default:
            this.show = false;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  #Phone {
    background: #fff !important;
    #header {
      height: 2rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.41rem;
      font-size: 0.8rem;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      box-sizing: border-box;
      .minus {
        div {
          width: 0.47rem;
          height: 0.08rem;
          background: #000A24;
          margin: 0.09rem 0;
        }
      }
    }

    #swipe_area_ph {
      position: relative;
      margin-top: 2.37rem;
      .swipe_text_area {
        position: absolute;
        top: 3.21rem;
        padding-left: 0.47rem;
      }

      .d_t {
        position: relative;
        animation-name: d1;
        animation-duration: 2s;
        animation-fill-mode: forwards;
        color: #B0B7BF;
        font-size: 0.4rem;
        margin-bottom: 1.01rem;
      }

      .d_b {
        position: relative;
        animation-name: d2;
        animation-duration: 2s;
        animation-fill-mode: forwards;
        color: #fff;
        font-size: 1.12rem;

        > div {
          margin-bottom: 1.25rem;
        }
      }

      @keyframes d1 {
        0% {
          transform: translateY(-4rem);
          opacity: 0;
        }
        50% {
          transform: translateY(-2rem);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      @keyframes d2 {
        0% {
          transform: translateY(5rem);
          opacity: 0;
        }
        50% {
          transform: translateY(2rem);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

      .van-swipe {
        height: 4.6rem;
      }

      .van-swipe-item {
        overflow: hidden;
      }

      .swipeBG1 {
        background-image: url("../../../assets/images/index/mobile_swipe.png");
        /*animation-name: swipe;*/
        animation-duration: 8s;
        animation-iteration-count: infinite;
      }

      .swipeBG2 {
        background-image: url("../../../assets/images/index/main-slider-1-1.jpg");
        animation-name: swipe;
        animation-duration: 8s;
        animation-iteration-count: infinite;
        animation-delay: 8s;

      }

      .swipeBG {
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        transform: scale(1);
        background-position: center;
        position: relative;

      }

      @keyframes swipe {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(1.5);
        }
      }
      .btns{
        padding: 0.6rem 1.39rem;
        background: $index_color;
        border-color: $index_color;
      }
    }

    #loanMoney_ph {
      padding: 0 0.41rem;

      .loanMoney_left_content {
        line-height: 0.96rem;

        > :nth-child(1) {
          color: #798490;
          font-size: 0.53rem;
          margin-bottom: 27px;
          margin-top: 1.4rem;
        }

        > :nth-child(2) {
          color: #0C2139;
          font-size: 0.8rem;
          margin-bottom: 0.87rem;
        }

        > :nth-child(3) {
          color: #004AA1;
          font-size: 0.53rem;
          margin-bottom: 0.81rem;
        }

        > :nth-child(4) {
          color: #798490;
          font-size: 0.43rem;
        }
      }
    }

    #loanMoney {
      margin-top: -0.1rem;

      .loanMoney_right_top {
        height: 1.5rem;
        line-height: 1.5rem;
        /*background: linear-gradient(180deg, #004AA1, #4678B2);*/
        background: $index_color;
        font-size: 0.47rem;
        color: #fff;
        text-align: center;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        position: relative;
        z-index: 2;

        .triangle {
          width: 100%;

          div {
            margin: 0 auto;
            width: 0px;
            height: 0px;
            border-top: 12px solid $index_color;
            border-left: 12px solid transparent;
            border-right: 12px solid transparent;
          }
        }
      }

      .loanMoney_right_content {
        padding: 1.49rem 1.03rem 0.5rem;
        box-shadow: 0 0 20px rgba(216, 216, 216, 0.7);

        .slide_item {
          margin-bottom: 0.47rem;

          .label {
            font-size: 0.37rem;
            color: #88929D;
            margin-bottom: 0.15rem;
          }

          .qj {
            font-size: 0.4rem;
            color: #88929D;
            font-weight: 500;
            margin-bottom: 0.32rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }

        .infos {
          .info_items {
            padding: 0.6rem 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            > :nth-child(1) {
              color: #88929D;
              font-size: 0.37rem;
            }

            > :nth-child(2) {
              color: #0C2139;
              font-size: 0.31rem;
              font-weight: 600;
            }
          }
        }

        .btns {
          width: 100%;
          height: 1.2rem !important;
          /*padding: 0.3rem 0;*/
          font-size: 0.48rem !important;
          margin-top: -0.89rem;
          background: $color!important;
          border-color: $color;
        }

        /deep/ .van-slider__button {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }

    #QS {
      padding-top: 1rem;

      .head_title {
        text-align: center;

        > :nth-child(1) {
          color: #798490;
          font-size: 0.48rem;
          margin-bottom: 0.79rem;
        }

        > :nth-child(2) {
          color: #0C2139;
          font-size: 0.8rem;
          margin-bottom: 0.97rem;
        }
      }

      .QS_content {
        position: relative;

        .container {
          /*display: flex;*/
          /*align-items: center;*/
          position: relative;
          z-index: 2;

          .q3 {
            position: absolute;
            bottom: 10px;
            left: -72px;
            z-index: 0;
            animation: q2 6s ease-in-out 3s infinite alternate;
          }

          @keyframes q2 {
            0% {
              transform: translateY(0px) translateX(0) rotate(0);
            }
            30% {
              transform: translateY(30px) translateX(50px) rotate(15deg);
              transform-origin: center center;
            }
            50% {
              transform: translateY(50px) translateX(100px) rotate(45deg);
              transform-origin: right bottom;
            }
            80% {
              transform: translateY(30px) translateX(50px) rotate(15deg);
              transform-origin: left top;
            }
            100% {
              transform: translateY(0px) translateX(0) rotate(0);
              transform-origin: center center;
            }
          }

          .QS_content_item {
            flex: 1;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            z-index: 2;
            text-align: center;

            .text {
              background: #fff;
              padding: 0 0.8rem 0.87rem;

              h4 {
                color: #0C2139;
                font-size: 0.56rem;
                font-weight: 600;
              }

              div {
                color: #798490;
                font-size: 0.48rem;
              }
            }

            img {
              transition: transform 500ms ease, opacity 500ms ease;
              opacity: 1;
              transform: scale(1);
              height: 5.85rem;
            }

            img:hover {
              cursor: pointer;
              transform: scale(1.05);
              opacity: 0.7;
            }
          }
        }

      }
    }

    #reason {
      padding: 1.6rem 0 0.3rem;
      background: #EFF2F6;
      position: relative;

      .q2 {
        position: absolute;
        right: 350px;
        top: 80px;
        animation: q2 5s linear infinite;
      }

      @keyframes q2 {
        0% {
          transform: translateY(0px) translateX(0) rotate(0);
        }
        30% {
          transform: translateY(30px) translateX(50px) rotate(15deg);
          transform-origin: center center;
        }
        50% {
          transform: translateY(50px) translateX(100px) rotate(45deg);
          transform-origin: right bottom;
        }
        80% {
          transform: translateY(30px) translateX(50px) rotate(15deg);
          transform-origin: left top;
        }
        100% {
          transform: translateY(0px) translateX(0) rotate(0);
          transform-origin: center center;
        }
      }

      .head_title {
        text-align: center;

        > :nth-child(1) {
          color: #798490;
          font-size: 0.48rem;
          margin-bottom: 0.77rem;
        }

        > :nth-child(2) {
          color: #0C2139;
          font-size: 0.8rem;
          margin-bottom: 0.8rem;
        }
      }

      .container {
        position: relative;

        .reason_content_item {
          flex: 1;
          background: #fff;
          border-radius: 5px;
          padding: 1.36rem 1.18rem;
          display: flex;
          align-items: center;
          border-bottom: 3px solid #fff;
          border-top: 3px solid #fff;
          width: 9.1rem;
          box-sizing: border-box;
          height: 2.79rem;
          margin: 0 auto 0.5rem;
          font-size: 0.48rem;
          color: #0F243B;

          > :nth-child(1) {
            margin-right: 0.55rem;
          }

          img {
            width: 1.51rem;
          }
        }

        .reason_content_item:hover {
          box-sizing: border-box;
          cursor: pointer;
          animation: example 2s linear forwards;
        }

        @keyframes example {
          from {
            border-bottom: 3px solid #fff;
          }
          to {
            border-bottom: 3px solid $index_color;
          }
        }

        .q1 {
          position: absolute;
          left: 10px;
          bottom: -45px;
          animation: q1 5s linear infinite;
        }

        @keyframes q1 {
          0%, 100% {
            transform: perspective(400px) translateY(0) rotate(0deg) translateZ(0px) translateX(0);
          }
          50% {
            transform: perspective(400px) rotate(-45deg) translateZ(20px) translateY(20px) translateX(20px);
          }
        }
      }
    }

    #lc {
      padding: 1.6rem 0 0;
      background: #fff;

      .head_title {
        text-align: center;

        > :nth-child(1) {
          color: #798490;
          font-size: 0.48rem;
          margin-bottom: 0.77rem;
        }

        > :nth-child(2) {
          color: #0C2139;
          font-size: 0.8rem;
          margin-bottom: 0.8rem;
        }
      }

      .container {
        .reason_content {
          display: flex;
          align-items: center;
          flex-direction: column;
          padding: 0 0.68rem;
          margin-top: -1rem;
          img {
            /*width: 5.33rem;*/
            height: 4.61rem;
            margin-bottom: 0.5rem;
            margin-top: 0.8rem;
          }

          div {
            /*color: #798490;*/
            line-height: 0.76rem;
            font-size: 0.43rem;
          }
        }

        .right {
          margin-top: 1.6rem;

          .items {
            background: $index_color;
            margin-bottom: 0.5rem;
            color: #fff !important;
            font-size: 0.48rem;
            border-radius: 5px;
            display: flex;
            align-items: center;
            width: 8.76rem;
            height: 2.43rem;
            line-height: 2.43rem;
            padding: 0 0.81rem;
            box-sizing: border-box;

            > :nth-child(1) {
              width: 1.6rem;
              height: 1.6rem;
              border-radius: 50%;
              background: #fff;
              color: $index_color;
              margin-right: 0.87rem;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
            }
          }
        }
      }
    }

    #dk {
      background: url("../../../assets/images/index/mobile_1.png") no-repeat right top;
      height: 9.81rem;
      background-size: cover;
      position: relative;

      #dk_zz {
        height: 100%;
        width: 100%;

        opacity: 0.7;
        position: absolute;
        z-index: 1
      }

      .container {
        > :nth-child(1) {
          color: #fff;
          text-align: center;
          padding-top: 2.04rem;

          > :nth-child(1) {
            font-size: 0.48rem;
            margin-bottom: 0.64rem;
          }

          > :nth-child(2) {
            font-size: 0.96rem;
          }
        }

        > :nth-child(2) {
          margin-top: 0.97rem;
          text-align: center;;
        }
      }
      .btns{
        width: 70%;
        background: $index_color;
        border-color: $index_color;
      }
    }

    #footer {
      background: url("../../../assets/images/index/footer-bg-1-1.jpg") no-repeat left top;
      height: 22rem;
      background-size: cover;
      padding-top: 1.35rem;
      box-sizing: border-box;

      .container {
        > div {
          padding: 0 0.6rem;

          div {
            color: #87909A;
            font-size: 0.4rem;
            line-height: 0.6rem;

            h4 {
              color: #fff;
              font-weight: 500;
              font-size: 0.48rem !important;
            }
          }
        }
      }
    }

    .popBox {
      min-height: 100vh;
      width: 80vw;
      background-color: #1d1c1c;
      padding: 0.47rem;
      box-sizing: border-box;
      position: relative;
      .header {
        font-size: 0.5rem;
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0.2rem 0 0.5rem;
        margin-bottom: 0.5rem;
      }

      .content {
        .item {
          font-size: 0.4rem;
          padding: 0.4rem 0;
          color: #fff;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
      }
      .version{
        position: absolute;
        bottom: 0.1rem;
        left: 50%;
        width: 100px;
        margin-left: -50px;
        text-align: center;
        font-size: 12px;
      }
    }

    .van-button {
      height: 1.2rem !important;
      width: 5.15rem;
      font-size: 0.64rem;
    }

    .line {
      width: 1.15rem;
      height: 0.08rem;
      background: $index_color;
      display: inline-block;
      vertical-align: middle;
    }
  }
  #headBtn{
    background-color: $color;
    border-color: $color;
    width: 100%!important;
    font-size: 0.4rem!important;
    height: 1rem!important;
    margin-top: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/mobile.vue